export enum PbhSvcShipmentTypeEnum {
  PbhSvcShipmentType = "PbhSvcShipmentType",
  DropShipment = 1,
  HandDelivery = 2,
  Dispatch = 3,
  LocalRepair = 4,
  ProvidedByCustomer = 5,
}
